<template>
    <div>
        <label>{{ input.label }}</label>
        <div
            :key="index"
            class="form-check"
            v-for="(option, index) in input.options"
        >
            <label class="form-check-label">
                <input
                    type="radio"
                    :name="input.name"
                    :value="option.id"
                    v-model="input.value"
                    class="form-check-input"
                    :checked="option.id === input.value"
                />
                {{ option.value }}
            </label>
        </div>
        <input-errors :error-messages="input.errors"></input-errors>
    </div>
</template>

<script>
import common from './common';

export default {
    mixins: [common],
}
</script>
